import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { MessageService } from './message.service';
import { CreativeTemplate } from '../models/creativeTemplate';
import { QueryBuilder } from '../models/queryBuilder';
import { QueryBuilderUpdate } from '../models/queryBuilderUpdate';

@Injectable({ providedIn: 'root' })

export class CreativeTemplateService { 
  private _ENDPOINT: string = '';

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private http: HttpClient,
    private messageService: MessageService, @Inject('BASE_URL') baseUrl) {
    this._ENDPOINT = baseUrl + 'api/creativeTemplates';   
  }
 
  getAll(brandId: number): Observable<Array<CreativeTemplate>> { 
    return this.http.get<Array<CreativeTemplate>>(this._ENDPOINT + '?brandId='+brandId);
  }

  getQuery(query: QueryBuilder): Observable<Array<CreativeTemplate>> {
    return this.http.post<Array<CreativeTemplate>>(this._ENDPOINT + "/GetQuery", query, this.httpOptions);
  }
  
  getById(id: any): Observable<CreativeTemplate> {
    const url = this._ENDPOINT+'/'+id;
    return this.http.get<CreativeTemplate>(url);
  }

  /** POST: add a new creativeTemplate to the server */
  add(creativeTemplate: CreativeTemplate): Observable<CreativeTemplate> {
    return this.http.post<CreativeTemplate>(this._ENDPOINT, creativeTemplate, this.httpOptions).pipe(
      tap((newCreativeTemplate: CreativeTemplate) => this.log('added creativeTemplate w/ id=${newCreativeTemplate.id}')),
      catchError(this.handleError<CreativeTemplate>('add'))
    );
  }

  /** POST: update the creativeTemplate on the server */
  addBulk(id: number, creativeTemplates: CreativeTemplate[]): Observable<any> {
    return this.http.post(this._ENDPOINT + "/" + id, creativeTemplates, this.httpOptions).pipe(
      catchError(this.handleError<any>('addBulk'))
    );
  }


  /** DELETE: delete the creativeTemplate from the server */
  delete(id: number): Observable<CreativeTemplate> {
    const url = this._ENDPOINT + '/' + id;

    return this.http.delete<CreativeTemplate>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted creativeTemplate id=${id}')),
      catchError(this.handleError<CreativeTemplate>('delete'))
    );
  }

  /** DELETE: delete the creativeTemplate from the server */
  deleteAll(id: number): Observable<CreativeTemplate> {
    const url = this._ENDPOINT + '/deleteAll/' + id;

    return this.http.delete<CreativeTemplate>(url, this.httpOptions).pipe(
      tap(_ => this.log('deleted creativeTemplate id=${id}')),
      catchError(this.handleError<CreativeTemplate>('delete'))
    );
  }

  /** PUT: update the creativeTemplate on the server */
  update(id: number, creativeTemplate: CreativeTemplate): Observable<any> {
    return this.http.put(this._ENDPOINT + "/" + id, creativeTemplate, this.httpOptions).pipe(
      tap(_ => this.log('updated creativeTemplate id=${creativeTemplate.Id}')),
      catchError(this.handleError<any>('update'))
    );
  }

  /** PUT: update the creativeTemplate on the server */
  updateBulk(updateModel: QueryBuilderUpdate): Observable<any> { 
    return this.http.put(this._ENDPOINT + "/updateBulk", updateModel, this.httpOptions).pipe( 
      catchError(this.handleError<any>('updateBulk'))
    );
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log('${operation} failed: ${error.message}');

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /** Log a CreativeTemplateService message with the MessageService */
  private log(message: string) {
    this.messageService.add('CreativeTemplateService: ${message}');
  }
}
